import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Button,
  Input,
  DatePicker,
  message,
} from "antd";
import { platformApi } from "../../../../../api";
import WrappedAccessoriesModal from "./TestModal";
import WrappedRescheduleModal from "./RescheduleModal";

import "./index.less";

const { Item } = Form;
const { Title, Text } = Typography;
const { Option } = Select;

const PaymentData = ({
  form,
  data,
  id,
  recvData,
  editable,
  groupCount,
  validate,
  setValidate,
  count,
  setCount,
  setCredits,
  setChecked,
}) => {
  const [senderId, setSenderId] = useState([])
  const [testFlag, setTestFlag] = useState(false);
  const [rescheduleFlag, setRescheduleFlag] = useState(false);
  const { getFieldDecorator, getFieldValue } = form;
  const [textCount, setTextCount] = useState(0);
  const [balSms, setBalSms] = useState(null)
  // const [count, setCount] = useState(0)

  useEffect(() => {
    platformApi.get("/api/company/senderId").then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data
        if (response.code === 200) {
          const senderIds = JSON.parse(response.data)
          setSenderId(senderIds)
          // Auto-select WhatsApp source / sole sender when creating a new task
          if (!recvData && Array.isArray(senderIds) && senderIds.length === 1) {
            form.setFieldsValue({ senderId: senderIds[0] });
            data.senderId = senderIds[0];
          }
        }
        else {
          message.error("Couldn't fetch SenderId")
        }
      } else {
        message.error("Couldn't fetch SenderId")
      }
    }).catch(() => {
      message.error("Couldn't fetch SenderId")
    })
    if (recvData) {
      form.setFieldsValue({
        senderId: recvData.senderId,
      });
    }
    validate.add(validatePage)
    setValidate(validate)
    data.textCount != null ? setTextCount(data.textCount) : setTextCount(0);
    // checkCredits();

  }, []);

  const checkCredits = () => {
    platformApi.get('/api/promotions/credits')
      .then(res => {
        let { data } = res;
        if (data.code === 200) {
          setBalSms(data.response)
          if (data.response < count) {
            setCredits(true)
            message.warn("There are not enough credits to send SMS, Please recharge. The save button will be enabled only after recharge")
          }
        }
      })
  }
  useEffect(() => {
    if (recvData) {
      form.setFieldsValue({
        senderId: recvData.senderId,
      });
      setTextCount(recvData.message.sms.length);
    }
  }, [recvData, editable]);


  const validatePage = () => {
    let isValid;
    form.validateFields((validationError) => {
      isValid = validationError === null;
    });
    if (isValid) {
      data.senderId = getFieldValue("senderId");
    }
    return isValid;
  };

  const addData = (reData) => {
    data.date = reData.date;
    data.time = reData.time;
    data.name = reData.name;
    if (reData.campaign) {
      data.campaign = reData.campaign;
    }
    if (typeof setChecked === "function") {
      setChecked(false);
    }
  };

  const taskStatus = recvData && recvData.status;
  const canReschedule =
    editable &&
    (!taskStatus || !["Sent", "Processing", "Failed"].includes(taskStatus));

  return (
    <Form style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
      <Text strong>Sender Mobile</Text>
      <Item label="Select Phone No" colon={false}>
        {getFieldDecorator("senderId", {
          rules: [{ required: true, message: "Select Phone No" }],
        })(
          <Select disabled={!editable} placeholder="Select Phone No">
            {senderId.map((data) => (
              <Select.Option key={data}>{data}</Select.Option>
            ))}
          </Select>
        )}
      </Item>
      <Row type="flex" justify="space-around">
        <Col span={8}>
          SMS Required :{" "}
          {count}{" "}
        </Col>
        <Col span={8}></Col>
        <Col span={8}>SMS Balance:{balSms}</Col>
      </Row>
      <br />
      <Row type="flex" justify="space-around">
        <Col span={8}>
          <Button
            disabled={!canReschedule}
            onClick={() => {
              setRescheduleFlag(true);
            }}
            type="primary"
          >
            Reschedule Task
          </Button>
        </Col>
        <Col span={8}></Col>
        <Col span={8}>
          <Button
            disabled={!editable}
            onClick={() => {
              setTestFlag(true);
            }}
          >
            Test
          </Button>
        </Col>
      </Row>
      <WrappedAccessoriesModal
        open={testFlag}
        close={() => {
          setTestFlag(false);
        }}
        checkCredits={checkCredits}
        templates={
          Array.isArray(data.templates)
            ? data.templates
            : Array.isArray(data.text)
            ? data.text
            : []
        }
        sms={data.templates || data.text}
        id={data.senderId || (senderId && senderId[0])}
      />
      <WrappedRescheduleModal
        emitData={(reData) => addData(reData)}
        open={rescheduleFlag}
        close={() => {
          setRescheduleFlag(false);
        }}
        taskId={recvData && recvData.id}
        taskStatus={taskStatus}
      />
    </Form>
  );
};

const WrappedPaymentData = Form.create()(PaymentData);

export default WrappedPaymentData;
